import React from "react";
import { Hidden } from "@material-ui/core";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import EqualizerIcon from "@material-ui/icons/Equalizer";

const clase = (item, selec, tipo = "") => (item === selec ? `item_selec${tipo}` : "item_modulo");

// Pestañas inferior-izquierda del módulo de Gestión de proyectos de vida.
export default function MenuGestion({ sele = "consulta", seleccionar = () => {} }) {
  const pintar = (app, claseN = "") => {
    if (!app) {
      return (
        <div className={claseN}>
          <BottomNavigation showLabels className={clase("consulta", sele)} onClick={() => seleccionar("consulta")}>
            <BottomNavigationAction label={"Consulta y seguimiento"} icon={<PeopleAltIcon />} />
          </BottomNavigation>
          <BottomNavigation showLabels className={clase("analisis", sele)} onClick={() => seleccionar("analisis")}>
            <BottomNavigationAction label={"Análisis de información"} icon={<EqualizerIcon />} />
          </BottomNavigation>
        </div>
      );
    }
    return (
      <div className={claseN}>
        <BottomNavigation showLabels>
          <BottomNavigationAction label={"Consulta y seguimiento"} icon={<PeopleAltIcon />} className={clase("consulta", sele, "_app")} onClick={() => seleccionar("consulta")} />
          <BottomNavigationAction label={"Análisis de información"} icon={<EqualizerIcon />} className={clase("analisis", sele, "_app")} onClick={() => seleccionar("analisis")} />
        </BottomNavigation>
      </div>
    );
  };

  return (
    <div>
      <div>
        <Hidden xsDown> {pintar(false, "menu_modulo")} </Hidden>
        <Hidden smUp> {pintar(true, "menu_modulo_app")}</Hidden>
      </div>
    </div>
  );
}
